import React from 'react';
import { useLocale } from 'next-intl';
import { Link } from '@/components/ui';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  /** Use light text for dark backgrounds (hero images) */
  light?: boolean;
  href?: string;
  onClick?: () => void;
  className?: string;
}

export const Logo = React.forwardRef<HTMLAnchorElement, LogoProps>(
  (
    { size = 'md', showText = true, light = false, href, onClick, className = '', ...props },
    ref,
  ) => {
    const locale = useLocale();

    const sizeClasses = {
      sm: {
        icon: 'h-6 w-6',
        text: 'text-sm',
        subtitle: 'text-xs',
      },
      md: {
        icon: 'h-8 w-8',
        text: 'text-base',
        subtitle: 'text-xs',
      },
      lg: {
        icon: 'h-10 w-10',
        text: 'text-lg',
        subtitle: 'text-xs',
      },
    };

    const currentSize = sizeClasses[size];

    return (
      <Link
        href={href ?? `/${locale}`}
        onClick={onClick}
        ref={ref}
        variant="default"
        color="default"
        className={`gap-2 ${className}`}
        {...props}
      >
        <div
          className={`bg-primary flex ${currentSize.icon} items-center justify-center rounded-xl`}
        >
          <span
            className="text-primary-foreground font-bold"
            style={{
              fontSize: size === 'sm' ? '0.875rem' : size === 'md' ? '1.125rem' : '1.25rem',
            }}
          >
            P
          </span>
        </div>
        {showText && (
          <div className="flex flex-col">
            <span
              className={`${light ? 'text-white' : 'text-foreground'} font-heading leading-none font-bold ${currentSize.text}`}
            >
              PlayPulse
            </span>
          </div>
        )}
      </Link>
    );
  },
);
Logo.displayName = 'Logo';
